import FocusTrap from 'focus-trap-react';
import React from 'react';
import { config, Text } from 'folds';
import { Menu, MenuItem } from './glass/GlassPrimitives';
import { stopPropagation } from '../utils/keyboard';
import { MembershipFilterItem } from '../hooks/useMemberFilter';

type MembershipFilterMenuProps = {
  items: MembershipFilterItem[];
  requestClose: () => void;
  selected: number;
  onSelect: (index: number) => void;
};
export function MembershipFilterMenu({
  items,
  selected,
  onSelect,
  requestClose,
}: MembershipFilterMenuProps) {
  return (
    <FocusTrap
      focusTrapOptions={{
        initialFocus: false,
        onDeactivate: requestClose,
        clickOutsideDeactivates: true,
        isKeyForward: (evt: KeyboardEvent) => evt.key === 'ArrowDown',
        isKeyBackward: (evt: KeyboardEvent) => evt.key === 'ArrowUp',
        escapeDeactivates: stopPropagation,
      }}
    >
      <Menu style={{ padding: config.space.S100 }}>
        {items.map((menuItem, index) => (
          <MenuItem
            key={menuItem.name}
            variant="Surface"
            aria-pressed={selected === index}
            size="300"
            radii="300"
            onClick={() => {
              onSelect(index);
              requestClose();
            }}
          >
            <Text size="T300">{menuItem.name}</Text>
          </MenuItem>
        ))}
      </Menu>
    </FocusTrap>
  );
}
